import { pickBy } from 'controls/utils';
import _ from 'lodash';

// for all api methods throw an exception if something fails handleError in actions will catch the error and display a message

export class Api {

  constructor() {
    this.store = null;
    this.user = null;
  }

  async initialize(store) {
    this.store = store;
    let user = localStorage.getItem('backstage-state');

    if (JSON.parse(user)?.state?.userInfo?.id) {
      user = JSON.parse(user);
      const oldIdToken = localStorage.getItem(`backstage-credentials-${user.state.userInfo.id}`);
      const idToken = await this.refreshToken(JSON.parse(oldIdToken), user.state.userInfo.id);

      if (idToken) {
        this.user = {
          ...user.state.userInfo, idToken: idToken?.idToken,
        };
        this.store.dispatch({ type: 'SET_USER', user: this.user });
      } else {
        this.store.dispatch({ type: 'SET_USER', user: { guest: true } });
      }
      return this.user;
    }
    this.store.dispatch({ type: 'SET_USER', user: { guest: true } });
    return null;
  }

  fetchJson = async (path, {
    authorize = false, method = 'POST', headers = {}, body, ...extra
  }) => {
    const token = authorize ? this.user.idToken : undefined;

    headers = _.pickBy({
      'Content-Type': body ? 'application/json' : undefined,
      'Authorization': authorize ? `Bearer ${token}` : undefined,
      ...headers,
    });

    if (body && !(body instanceof FormData)) {
      body = JSON.stringify(body);
    }

    const result = await fetch(path, pickBy({
      method,
      headers,
      body,
      ...extra,
    }));

    if (result?.status === 401 && authorize) {
      return;
    }

    const json = await result.json().catch({});

    return { status: result?.status, data: json };
  };

 getCustomersOffers = async () => {
   const { status, data } = await this.fetchJson(`${process.env.REACT_APP_CUSTOMERS}/management/functions/get-customers-offers`, { method: 'POST', authorize: this.user !== null/* , headers: { clientId: '14' } */ });
   if (status === 200) {
     const { freeTrial, hasActiveTrial, freeSubTier } = await this.getCustomerPayments();
     const hasAnySubscription = (data.result.offers.some(({ entityInfo }) => entityInfo.customerSubscribed) || freeSubTier.length > 0);

     return [_.groupBy(data.result.offers.filter(({ entityInfo }) => entityInfo.plan).map((item) => ({
       price: item.entityInfo.price || item.entityInfo.plan.price,
       currency: item.entityInfo.currency || item.entityInfo.plan.currency,
       offerId: item.entityInfo.offerId || 1,
       customerEligible: item.entityInfo.customerEligible,
       customerSubscribed: item.entityInfo.customerSubscribed || (freeSubTier && item.metadata.description.us.toLowerCase().includes(freeSubTier)),
       productIds: item.entityInfo.plan.processorId,
       frequencyMonths: item.entityInfo.plan.frequencyMonths,
       hasAnySubscription,
       isActive: item?.entityInfo?.CTA?.isActive,
       isFreeTrial: item?.entityInfo?.CTA?.isFreeTrial,
       isUpgrade: item?.entityInfo?.CTA?.isUpgrade,
       isPurchasable: item?.entityInfo?.CTA?.isPurchasable,
       ...item.metadata,
     })), 'frequencyMonths'), { freeTrial, hasActiveTrial }];
   }
 };

getPurchaseToken = async (offerId, productIds, source = 'fastspring') => {

  const body = {
    ProductIds: [], OfferId: offerId, Email: this.user.email, PlanIds: [productIds],
  };

  const { status, data } = await this.fetchJson(`${process.env.REACT_APP_CUSTOMERS}/token/${source}/validate`, { method: 'POST', authorize: true, body });
  if (status === 200) {
    return data.token;
  }
}

getCustomerPayments = async () => {
  if (!this.user || this.user.guest) {
    return { freeTrial: true, hasActiveTrial: false, freeSubTier: '' };
  }

  const { status, data } = await this.fetchJson(`${process.env.REACT_APP_CUSTOMERS}/account-details/user-subscriptions`, { method: 'GET', authorize: this.user !== null });

  if (status === 200) {
    if (data?.data) {
      const hasActiveTrial = (data.data.find(({ offer }) => offer?.id === 1));
      const freeSubTier = (data.data.find(({ subscriptionTypeId }) => subscriptionTypeId === 3))?.tierDescription?.toLowerCase();
      return { freeTrial: data.data.every(({ offer }) => offer?.id !== 1), hasActiveTrial: hasActiveTrial && hasActiveTrial?.statusId === 3, freeSubTier: freeSubTier || '' };
    }
  }
  return { freeTrial: true, hasActiveTrial: false, freeSubTier: '' };
}

refreshToken = async ({ refreshToken }) => {
  const body = { token: refreshToken };

  const { status, data } = await this.fetchJson(`${process.env.REACT_APP_REFRESH}`, { method: 'POST', body });

  if (status >= 200 && status <= 300) {
    return data;
  }
}

}
